<template >
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left">
      <el-form :model="dataForm" :rules="dataRules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
               label-width="80px">
        <el-form-item label="名称" prop="ruleName" >
          <el-input v-model="dataForm.ruleName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="审核人" prop="checker" >
          <el-select clearable  reserve-keyword filterable remote :remote-method="searchChecker"    v-model="dataForm.checker" placeholder="输入姓名" :loading="loading">
            <el-option
                    v-for="item in checkers"
                    :key="item.id"
                    :label="item.xm"
                    :value="item.id">
              <span style="float: left">{{ item.xm }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批人" prop="approver" >
          <el-select clearable  reserve-keyword filterable remote :remote-method="searchChecker1"    v-model="dataForm.approver" placeholder="输入姓名" :loading="loading1">
            <el-option
                    v-for="item in approvers"
                    :key="item.id"
                    :label="item.xm"
                    :value="item.id">
              <span style="float: left">{{ item.xm }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="bmid">
          <el-select clearable :disabled="deptdisable"   filterable    v-model="dataForm.bmid" placeholder="请选择大队">
            <el-option
                    v-for="item in depts"
                    :key="item.bmid"
                    :label="item.bmmc"
                    :value="item.bmid"
                    :disabled="deptdisable">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {

      const checkAge = (rule, value, callback) => {
        if(value) {
          if ( !/^\d+$/.test(value)) {
            callback(new Error('请输入数字值'));
          } else {
            callback();
          }
        } else callback();
      }
      return {
        visible: false,
        deptdisable:false,
        depts:[],
        checkers:[],
        approvers:[],
        loading:false,
        loading1:false,
        rsDisabled:false,
        dataForm: {
         id:'',
         ruleName:'',
         checker:'',
         approver:'',
         bmid:''
        },

        dataRules: {
          ruleName: [{
            required: true,
            message: '考勤组名称不能为空',
            trigger: ['blur']
          }],
          approver: [{
            required: true,
            message: '审核人不能为空',
            trigger: ['blur']
          }]
        }
      }
    },
    created () {

    },
    methods: {
      init (id) {

        this.dataForm.id = id
        this.visible = true
        this.checkers=[]
        this.approvers=[]
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          this.getDepts()
          if(this.dataForm.id) {
            this.$http({
              url: `/bjba/kqrules/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              console.log('2222222222')
              this.dataForm.id=data.data.id;
              this.dataForm.ruleName=data.data.ruleName;
              this.dataForm.checker=data.data.checker;
              this.dataForm.approver=data.data.approver;
              this.dataForm.bmid=data.data.bmid;
              if(data.data.checkers) {
                this.checkers.push(data.data.checkers);
              }
              if(data.data.approvers) {
                this.approvers.push(data.data.approvers);
              }
            })
          }
        })
      },
      getDepts() {
        let that = this;
        this.$request.get('/bjba/kqtj/getFirstMentForUser',{
          params: {
            userid:this.$store.getters.username
          }

        }).then(res => {
          that.depts = res.data
          if(this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if (this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
              var zw = this.$store.getters.user.zw;
              if (zw) {
                if (zw == '01' || zw == '02' || zw == '03') {
                  this.dataForm.bmid = that.depts[0].bmid
                  this.deptdisable = true
                }
              }

            }
          }
        })
      },
      searchChecker(query) {
        console.log(query)
        if (query !== '') {
          this.loading = true;
          // setTimeout(() => {
          //   this.loading = false;
          //   this.options = this.list.filter(item => {
          //     return item.label.toLowerCase()
          //             .indexOf(query.toLowerCase()) > -1;
          //   });
          // }, 200);
          this.$request.get('/bjba/yhgl/findUserListByxm',{
            params: {
              xm:query
            }

          }).then(res => {
            this.loading =false
            this.checkers = res.data.data

          })
        } else {
          this.checkers = [];
        }
      },
      searchChecker1(query) {
        console.log(query)
        if (query !== '') {
          this.loading1 = true;

          this.$request.get('/bjba/yhgl/findUserListByxm',{
            params: {
              xm:query
            }

          }).then(res => {
            this.loading1 =false
            this.approvers = res.data.data

          })
        } else {
          this.approvers = [];
        }
      },
      // 表单提交
      dataFormSubmit () {

        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            const data = this.dataForm
            this.$http({
              url: '/bjba/kqrules/save',
              method: 'post',
              data
            }
            ).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              }else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: "error",
                  duration: 1500
                })
              }
            })
          }
        })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .el-popper {
    max-height: 500px;
    max-width: 200px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
